import {
  showNotification,
  showSuccessNotification,
  showErrorNotification,
  showWarningNotification,
  showInfoNotification
} from '../components/ui/notification';

export const showToast = (title, description, status = 'info') => {
  showNotification(title, description, status);
};

export const showSuccessToast = (title, description) => {
  showSuccessNotification(title, description);
};

export const showErrorToast = (title, description) => {
  showErrorNotification(title, description);
};

export const showWarningToast = (title, description) => {
  showWarningNotification(title, description);
};

export const showInfoToast = (title, description) => {
  showInfoNotification(title, description);
};
